import { render, staticRenderFns } from "./WishlistSidebar.vue?vue&type=template&id=7432c80c&scoped=true"
import script from "./WishlistSidebar.vue?vue&type=script&lang=js"
export * from "./WishlistSidebar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./WishlistSidebar.vue?vue&type=style&index=0&id=7432c80c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./WishlistSidebar.vue?vue&type=style&index=1&id=7432c80c&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7432c80c",
  "06d671b6"
  
)

export default component.exports